import { createFileRoute } from "@tanstack/react-router"
import { ResetPasswordForm } from "@/components/ui/auth/ResetPasswordForm"

export const Route = createFileRoute("/reset-password")({
  component: ResetPasswordPage,
})

function ResetPasswordPage() {
  return <ResetPasswordForm />
}
